<template>
  <div class="login_con" :style="boxStyle">
    <div class="l_tit">机构入驻</div>
    <form class="reg_con" data-vv-scope="form1" novalidate>
      <p>
        <input v-validate="'required'" v-model="form1.name" name="name" type="text"  class="w365 put_txt input_three" id="registerOne"  placeholder="企业名称"/>
      </p>
      <i class="spa6">{{ errors.first('form1.name') }}</i>
      <p>
        <input v-validate="'required'" v-model="form1.code" name="code" type="text"  class="w365 put_txt input_three" id="registerTwo" placeholder="企业代码"/>
      </p>
      <i class="spa7">{{ errors.first('form1.code') }}</i>
      <p>
        <select name="member" v-model="form1.member" v-validate="'required'">
          <option value="">机构规模</option>
          <option v-for="item in selects" :key="item.id" :value="item.value">{{item.label}}</option>
        </select>
      </p>
      <i class="spa7">{{ errors.first('form1.member') }}</i>
      <dl>
        <dt>购买模块</dt>
        <dd style="padding-top:0;">
          <span v-for="m in modules" :key="m.serviceId" @click="clickEffects($event)">
            <input name="ziyuan" type="checkbox" @click='checkedOne(m.serviceId)' /><label>{{m.name}}</label>
          </span>
        </dd>
      </dl>
      <p class="wrap w264">
        <input name="" type="button" class="login_btn login_b input_two" value="下一步" id="sub3" @click="validateForm('form1')" />
      </p>
    </form>
  </div>
</template>
<script>
import config from '@/config'
import api from '@/api'
import { init } from '../common/loginNreg/effects.js'
import utils from '@/utils'
import '@/utils/validator.js'
export default {
  components: {},
  mounted () {
    init()
    this.getData()
    this.form1 = this.form // 继承父组件的form对象
    this.form1.member = ''
    this.form1.serviceIdList = ''
  },
  data () {
    return {
      form1: {},
      selected: '',
      selects: [],
      selectedModules: [], // 选择的模块
      modules: []
    }
  },
  computed: {
    boxStyle () {
      if (!this.isNew) {
        return {
          minHeight: '220px'
        }
      }
    }
  },
  methods: {
    popup (msg) {
      this.$toasted.show(msg)
    },
    validateForm (scope) {
      var bus = this
      this.$validator.validateAll(scope).then(function (result) {
        if (result) {
          bus.toNextStep()
        } else {
          bus.popup('请确保信息正确与完整')
          return false
        }
      })
    },
    toNextStep () {
      this.form1.serviceIdList = utils.arr2str(this.selectedModules)
      this.$emit('to-reg-step2')
    },
    getData () {
      var that = this
      api.get(config.bylBaseCenterPath, '/dict/findList', {
        type: 'entMember',
        pageNo: 1,
        pageSize: 100
      }, function (r) { // 正常
        that.selects = r.data
      })
      this.getModules()
    },
    getModules () {
      var that = this
      api.post(config.bylApiPath, '/entService/search', null, function (r) { // 正常
        that.modules = r.data
      })
    },
    clickEffects (e) {
      var $elem = $(e.target)
      if ($elem.is('input')) {
        $elem.toggleClass('focus')
      }
    },
    checkedOne (id) {
      let idIndex = this.selectedModules.indexOf(id)
      if (idIndex >= 0) {
        this.selectedModules.splice(idIndex, 1)
      } else {
        this.selectedModules.push(id)
      }
    }
  },
  props: ['isNew', 'form']
}
</script>
<style>
  @import '../common/loginNreg/login.css';
</style>



// WEBPACK FOOTER //
// src/components/common/org-reg/reg1.vue